import * as React from 'react';
import useSpotifyAuth from './hooks/spotifyAuth';

// const HTMLAudioApp = React.lazy(() => import('./components/HTMLAudioApp'));
const MainApp = React.lazy(() => import('./components/MainApp'));
const LoginPage = React.lazy(() => import('./components/LoginPage'));

function App() {
  const { accessToken, updateTokens } = useSpotifyAuth();
  // return <HTMLAudioApp />
  return accessToken ? (
    <MainApp accessToken={accessToken} />
  ) : (
    <LoginPage updateTokens={updateTokens} />
  );
}

export default App;
